export default function script_tabAccordion() {
  $(function($){
    const tabAccordion = $('#tabAccordion'),
          tabBtn       = tabAccordion.children('div').children('div').children('div').children('a'),  //#tabAccordionからのボタンの相対位置
          clickWord    = tabBtn.html(),
          slideSpeed   = 500;
  
    tabBtn.on('click', function(){
      if($(this).hasClass('btnAcv')){
        $(this).parents('.AccordionBox').children('.AccordionBox__body').slideUp(slideSpeed);  //ボタンからのアコーディオンコンテンツの相対位置にslideUp
        $(this).html(clickWord);
        $(this).removeClass('btnAcv');
      } else {
        $(this).parents('.AccordionBox').children('.AccordionBox__body').slideDown(slideSpeed);  //ボタンからのアコーディオンコンテンツの相対位置にslideDown
        $(this).html('閉じる <i class="fas fa-times"></i>');
        $(this).addClass('btnAcv');
      }
    });
  });
}
